import React from 'react';
import {Header} from '@unthinkable/react-screen-components';
import {useStyles} from '@unthinkable/react-theme';
import {FormHeaderStyle} from './theme';

export const FormHeader = props => {
  const styles = useStyles(FormHeaderStyle);
  return <Header styles={styles} {...props} />;
};
